gsap.registerPlugin(ScrollTrigger, ScrollSmoother);